import { IUser, IUserProfile, IUserShort, IUserStatus } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

import {
	IGetUserContactsCriteria,
	IGetUserSessionInfoResult,
	IGetUserSettingsResult,
	IGetUserStatusCriteria,
	ICowokersCriteria,
	IRecipientResolve,
	IRecipientResponse,
	IUserShortInfo,
	IUserSignatures,
} from './types';

export abstract class UsersDataHttpService {
	abstract getStatus(criteria: IGetUserStatusCriteria): Observable<IUserStatus[]>;

	/**@deprecated */
	abstract getMembersInGroup(groupId: number): Observable<{ id: number; name: string; type: string }[]>;

	abstract getMembersGroup(groupId: number): Observable<any>;

	abstract getSettings(userId: number): Observable<IGetUserSettingsResult>;

	abstract getUiSettings(userId: number): Observable<any>;

	abstract postUiSettings(userId: number, body: any): Observable<any>;

	abstract getUserInfo(userId: number): Observable<IUser>;

	abstract getUserProfile(userId: number): Observable<IUserProfile>;

	abstract getSessionUserInfo(): Observable<IGetUserSessionInfoResult>;

	abstract getContacts(criteria?: Partial<IGetUserContactsCriteria>): Observable<IUser[]>;

	abstract searchContacts(criteria?: Partial<IGetUserContactsCriteria>): Observable<IUser[]>;

	abstract getQuickReplies(): Observable<string[]>;

	abstract getSessionUserSharedData<T = any>(propertyPath?: string): Observable<T>;

	abstract setSessionUserSharedData<T = any>(value: any, propertyPath?: string): Observable<T>;

	abstract getCoworkers<T = any>(criteria: ICowokersCriteria): Observable<T>;

	abstract getContactsWithGroups(criteria?: Partial<IRecipientResolve>): Observable<IRecipientResponse>;

	abstract getUsersShortInfo(criteria?: Partial<IUserShortInfo>): Observable<IUserShort[]>;

	abstract getSignatures(): Observable<IUserSignatures>;
}
